<template>
  <div class="add-page">
    <div>
      <div class="detail-title">
        <span>考生姓名： {{form.examineeName}}</span>
        <span>准考证： {{form.admissionTicketNo}}</span>
        <span>账号： {{form.receiverPhone}}</span>
      </div>
      <div class="detail-title">
        <span>考试名称： {{form.batchName}}</span>
        <span>分类： {{form.specialtyParentName}}</span>
        <span>专业： {{form.specialtyName}}-{{form.gradeName}}</span>
      </div>
      <div class="detail-title">
        <span v-if="!form.batchMode">预约状态： {{$enums.isChoiceScene[form.isChoiceScene]}}</span>
        <span>考试状态： {{$enums.recordExamStatus[form.status]}}</span>
        <span>中断次数： {{form.interruptNum}}</span>
      </div>
      <div class="detail-title">
        <span>预约考试时间： {{form.beginTime}}-{{form.endTime}}</span>
      </div>
      <div>
        <!--        <el-button style="margin: 20px 0;" type="primary">主机位</el-button>-->
        <div v-if="system" style="display: flex;justify-content: space-between;margin: 20px 0;">
          <span>机型：{{system.deviceModel}}</span>
          <span>系统：{{system.osType}}</span>
          <span>系统版本号：{{system.osVersion}}</span>
          <span>APP名称：{{system.appName}}</span>
          <span>版本号：{{system.appVersion}}</span>
        </div>
        <div>
          <div v-if=" list && list.length >0" style="line-height: 30px;" v-for="(item,index) in list" :key="index">
            <span style="margin-right: 20px;">{{$moment(item.traceTime).format('YYYY-MM-DD HH:mm:ss')}}</span>
            <span>{{item.traceDes}}</span>
          </div>
          <div v-if="list && list.length ==0" style="text-align: center;margin: 20px 0;">暂无信息</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "result-trajectory",
  data () {
    return {
      form: {},
      list: null,
      system: {},
      examId: this.$route.query.examId
    }
  },
  async created () {
    await this.initForm()
  },
  methods: {
    async initForm () {
      this.form = await this.$HTTP.ApiMusicbasis.getExamineeInfo(this.examId)
      let info = await this.$HTTP.ApiMusicbasis.getTrajectory(this.examId)
      this.system = info[0]
      this.list = info
    }
  }
}
</script>

<style scoped>
.detail-title {
  line-height: 35px;
}

.detail-title span {
  margin-right: 20px;

}

.add-page {
  height: 65vh;
}
</style>
